import React from 'react'
import { withRouter } from 'react-router-dom'
import Forgot from './Forgot'
import Reset from './Reset'
import Hero from './Hero'

class Main extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			token: false
		}
	}
	
	componentWillMount() {
		let token = this.props.match.params.token
		if (token) {
			this.setState({
				token: true
			})
		} else {
			this.setState({
				token: false
			})
		}
	}
	
	render() {
		if (this.state.token) {
			return (
				<div>
					<Hero heading={"Password Reset"} />
					<Reset />
				</div>
			)
		}
		return (
			<div>
				<Hero heading={"Forgot Password?"} />
				<Forgot />
			</div>
		)
	}
}

export default withRouter(Main)


// WEBPACK FOOTER //
// ./src/components/Reset/Main.js